var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#D3FFDD",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 23C7.47715 23 3 18.5229 3 13C3 7.47715 7.47715 3 13 3C18.5229 3 23 7.47715 23 13C23 18.5229 18.5229 23 13 23ZM17.1298 11.0447L17.9651 10.6356L17.1468 8.96475L16.3113 9.37394C14.492 10.2651 13.0833 11.7941 12.1503 13.0406C11.8269 13.4726 11.554 13.8795 11.3345 14.2287C11.0749 14.0037 10.8188 13.8174 10.5931 13.6686C10.3449 13.5049 9.85239 13.2493 9.66612 13.1526C9.65861 13.1487 9.6516 13.145 9.64513 13.1417L8.7901 12.7753L8.05723 14.4853L8.90986 14.8507C9.03047 14.9134 9.37365 15.093 9.56896 15.2219C9.96784 15.4848 10.4223 15.8572 10.7492 16.3242L11.653 17.6154L12.3461 16.2009C12.4005 16.099 12.5596 15.8011 12.6696 15.6138C12.89 15.2383 13.2169 14.7202 13.6396 14.1555C14.4972 13.01 15.6933 11.7483 17.1298 11.0447Z",
    fill: "#1D9F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreen);
export default __webpack_public_path__ + "static/media/tick_green.bb58151d8562be1b5f2dfbf5e9a37a00.svg";
export { ForwardRef as ReactComponent };